import * as constants from "./constants";
import { fromJS } from "immutable";
import { actionCreators as actionCreatorsFile } from "../../../common/upload_file_progress/store";
import API from "../../../server";
import { getUpdatedVariationLineItems } from "common/lineitem/sharedComponent";
import { VARIATION } from "../../../utils/constants";
import { generatePercentage, roundAndMultiply } from "utils/helpers/math";

export const initialFileList = (fileList) => {
  return {
    type: constants.INITIAL_FILE_LIST,
    fileList: fileList,
  };
};

export const getInitialVariationsItems = (proId, contractId, callback) => {
  return (dispatch) => {
    API.read_contract(proId, contractId)
      .then((res) => res.data)
      .then((res) => res.data.data)
      .then((res) => {
        res.variation_items = getUpdatedVariationLineItems(res.variation_items);
        dispatch(setValue("contractInfo", fromJS(res)));
        if (res.variation_items !== undefined) {
          dispatch(initialList(res));
        } else {
          dispatch(emptyList());
        }
        callback?.();
      });
  };
};
//get inital line item to the table
export const initialList = (result) => ({
  type: constants.INITIAL_ITEM_LIST,
  variationsitem: fromJS(result.variation_items),
  variationsitemTotal: result.total_variations,
});

//update line item to the table
export const updateVariationLineItem = (result, lineId, lineitemDetails) => ({
  type: constants.UPDATE_VARIATION_LINEITEM,
  result,
  lineId,
  lineitemDetails,
});

export const updateSingleVariationsItem = (
  proId,
  contractId,
  lineId,
  extraInfo,
  callbackFunction,
) => {
  return (dispatch) => {
    API.update_one_lineitem(proId, contractId, lineId, extraInfo).then(
      (res) => {
        API.read_contract(proId, contractId)
          .then((res) => res.data)
          .then((res) => res.data.data)
          .then((res) => {
            const lineItemDetails = res.variation_items.find(
              (item) => item.id === lineId,
            );
            dispatch(updateVariationLineItem(res, lineId, lineItemDetails));
            if (callbackFunction) {
              callbackFunction(lineItemDetails);
            }
          });
      },
    );
  };
};

//to empty the table when there is no data
export const emptyList = () => ({
  type: constants.EMPTY_ITEM_LIST,
});

export const createNewRow = (
  proId,
  contractId,
  tableList,
  files,
  table,
  lineitemOption,
  callback,
) => {
  tableList["quantity"] = roundAndMultiply(tableList.quantity, 100);
  tableList["rate"] = roundAndMultiply(tableList.rate, 100);
  tableList["lineitem_options"] = lineitemOption;
  let itemData = JSON.stringify(tableList);
  var dataSend = new FormData();
  files.map((item) => {
    return dataSend.append("attachments", item);
  });
  dataSend.append("data", itemData);
  return (dispatch) => {
    dispatch(setLoading(true));
    API.upsert_one_lineitem(proId, contractId, dataSend, "variations", {
      mimeType: "multipart/form-data",
    })
      .then((res) => res.data)
      .then((res) => {
        dispatch(getInitialVariationsItems(proId, contractId, callback));
      });
  };
};

//add child line item to the project and clean the input
export const createNewChildRow = (
  proId,
  contractId,
  tableList,
  files,
  parentItemId,
  table,
  lineitemOption,
  callback,
) => {
  tableList["quantity"] = roundAndMultiply(tableList.quantity, 100);
  tableList["rate"] = roundAndMultiply(tableList.rate, 100);
  tableList["lineitem_options"] = lineitemOption;
  (tableList.extra_info ??= {}).section = VARIATION;
  let itemData = tableList;
  itemData = JSON.stringify(itemData);
  var dataSend = new FormData();
  files.map((item) => {
    return dataSend.append("attachments", item);
  });
  dataSend.append("data", itemData);
  return (dispatch) => {
    dispatch(setLoading(true));
    API.create_one_lineitem_child(proId, contractId, parentItemId, dataSend, {
      mimeType: "multipart/form-data",
    })
      .then((res) => res.data)
      .then((res) => {
        dispatch(getInitialVariationsItems(proId, contractId, callback));
      });
  };
};

const setLoading = (status) => ({
  type: constants.LOADING_STATUS_CHANGE,
  status,
});
export const deleteLineItem = (proId, contractId, itemId, callback) => {
  return (dispatch) => {
    dispatch(setLoading(true));
    API.delete_one_lineitem(proId, contractId, itemId)
      .then((res) => res.data)
      .then((res) => {
        callback?.();
        dispatch(getInitialVariationsItems(proId, contractId));
      });
  };
};
export const changeFilesList = (result) => ({
  type: constants.CHANGE_FILE_LIST,
  files: result,
});
export const cancelOneFile = (result) => ({
  type: constants.CANCEL_ONE_FILE,
  value: result,
});

export const reset = () => ({
  type: constants.RESET,
});

export const updateLineItemsSortOrder = (proId, contractId, lineItems) => {
  return (dispatch) => {
    API.update_sort_order(proId, contractId, lineItems)
      .then((res) => res.data)
      .then((res) => {
        dispatch(getInitialVariationsItems(proId, contractId));
      });
  };
};

export const updateLineItem = (proId, contractId, lineId, value, callback) => {
  value.quantity = roundAndMultiply(value.quantity, 100);
  value.rate = roundAndMultiply(value.rate, 100);
  if (value.submit_date && value.submit_date.indexOf("T") !== -1) {
    value.submit_date = value.submit_date.split("T")[0];
  }
  if (value.approved_date && value.approved_date.indexOf("T") !== -1) {
    value.approved_date = value.approved_date.split("T")[0];
  }

  //add the id of lineitem so that api server knows it's an update
  value["id"] = lineId;
  let data = new FormData();
  data.append("data", JSON.stringify(value));

  return (dispatch) => {
    dispatch(setLoading(true));
    API.upsert_one_lineitem(proId, contractId, data, "variations", {
      mimeType: "multipart/form-data",
    })
      .then((res) => res.data)
      .then(() => {
        dispatch(getInitialVariationsItems(proId, contractId));

        if (callback) {
          callback();
        }
      });
  };
};
export const deleteFile = (proId, contractId, lineId, fileId) => {
  return (dispatch) => {
    API.delete_one_file(proId, contractId, lineId, fileId)
      .then((res) => res.data)
      .then((res) => res.data.file)
      .then((res) => {
        dispatch(initialFileList(res));
        dispatch(getInitialVariationsItems(proId, contractId));
      });
  };
};

export const uploadFileToDB = (proId, contractId, lineId, files) => {
  return (dispatch) => {
    if (files.size) {
      let promiseArr = [];
      files.forEach((item) => {
        let dataSend = new FormData();
        dataSend.append("attachments", item.get("file"));
        let config = {
          mimeType: "multipart/form-data",
          onUploadProgress: (progress) => {
            const { loaded, total } = progress;
            const percentageProgress = generatePercentage(loaded, total);
            dispatch(
              actionCreatorsFile.setUploadProgress(
                item.get("id"),
                percentageProgress,
              ),
            );
          },
        };
        var p1 = API.upload_one_file(
          proId,
          contractId,
          lineId,
          dataSend,
          config,
        );
        promiseArr.push(p1);
      });
      Promise.all(promiseArr)
        .then((resArr) => resArr.map((res) => res.data))
        .then((res) => {
          let fileList = [];
          for (var item of res) {
            for (var item1 of item.data.file) {
              let flag = true;
              for (var item2 of fileList) {
                if (item1.id === item2.id) {
                  flag = false;
                }
              }
              if (flag) {
                fileList.push(item1);
              }
            }
          }
          dispatch(actionCreatorsFile.clearFiles());
          dispatch(initialFileList(fileList));
          dispatch(getInitialVariationsItems(proId, contractId));
        })
        .catch((error) => {
          if (error.response) {
            alert(error.response.data.data.errors);
          } else {
            console.log(error.message);
          }
        });
    }
  };
};

export const updateLineApprovalStatus = (
  proId,
  contractId,
  lineItemId,
  status,
  reason,
) => {
  const data = reason ? { reason } : {};
  return (dispatch) => {
    API.update_variation_lineitem_status(
      proId,
      contractId,
      lineItemId,
      status,
      data,
    )
      .then((res) => res.data)
      .then((res) => {
        dispatch(getInitialVariationsItems(proId, contractId));
      });
  };
};

export const setValue = (name, value) => ({
  type: constants.SET_VALUE,
  name,
  value,
});
